import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

/**
 * Bulle d'aide cliquable : un « ? » qui ouvre une note explicative au clic
 * (se ferme en cliquant ailleurs). Sert de mini-notice pour les concepts
 * B2B pas évidents pour les nouveaux utilisateurs.
 *
 * Props :
 *  - title    : titre de la note
 *  - children : contenu de l'explication (texte ou JSX)
 *  - placement: position du popover (def. "auto")
 */
const HelpTip = ({ title, children, placement = "auto" }) => (
  <OverlayTrigger
    trigger="click"
    rootClose
    placement={placement}
    overlay={
      <Popover id={`help-${(title || "tip").replace(/\s+/g, "-").toLowerCase()}`} style={{ maxWidth: 360 }}>
        {title && <Popover.Title as="h3">{title}</Popover.Title>}
        <Popover.Content style={{ fontSize: "0.85rem", lineHeight: 1.45 }}>
          {children}
        </Popover.Content>
      </Popover>
    }
  >
    <span
      role="button"
      tabIndex={0}
      onClick={(e) => e.stopPropagation()}
      style={{ cursor: "pointer", color: "#5bc0de", marginLeft: 4 }}
      title="Aide"
    >
      <FontAwesomeIcon icon={faQuestionCircle} />
    </span>
  </OverlayTrigger>
);

export default HelpTip;
